module.exports = __webpack_public_path__ + "img/type_2.663c60de.png";